import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';

import {
  getStorageValue,
  setStorageValue,
} from '../../helpers/storage';

import { COLORS } from '../../constants/colors';
import { NOTIFICATION_TYPES } from './constants';

import {
  GetMessageDataType,
  GetNotificationType,
  GetSpecificNotificationType,
} from './interfaces';
import { StorageValues, StorageTypes } from '../../interfaces/storage';

export const getMessageData: GetMessageDataType = (type) => {
  const messageData = {
    [NOTIFICATION_TYPES.ERROR]: {
      icon: ErrorRoundedIcon,
      color: COLORS.ERROR,
      background:
        'radial-gradient(45.47% 122.24% at 97.04% -19.65%, rgba(72, 18, 18, 0.9) 0%, rgba(11, 11, 13, 0.9) 100%)',
    },
    [NOTIFICATION_TYPES.WARNING]: {
      icon: ErrorRoundedIcon,
      color: '#FFBB54',
      background:
        'radial-gradient(45.47% 122.24% at 97.04% -19.65%, rgba(197, 131, 34, 0.9) 0%, rgba(11, 11, 13, 0.9) 100%)',
    },
    [NOTIFICATION_TYPES.SUCCESS]: {
      icon: CheckCircleRoundedIcon,
      color: '#53CD3F',
      background:
        'radial-gradient(45.47% 122.24% at 97.04% -19.65%, rgba(35, 72, 18, 0.9) 0%, rgba(11, 11, 13, 0.9) 100%)',
    },
  };

  return messageData[type];
};

export const getNotification: GetNotificationType = ({
  title = '',
  message,
  ...props
}) => {
  return {
    title,
    message,
    ...props,
  };
};

export const getErrorNotification: GetSpecificNotificationType = ({
  title = '',
  message,
  ...props
}) => {
  return getNotification({
    title,
    message,
    type: NOTIFICATION_TYPES.ERROR,
    ...props,
  });
};

export const setDismissNotificationMessage = (
  message: string,
  storageType: StorageTypes,
) => {
  const dismissMessages =
    getStorageValue<string[]>(
      StorageValues.DismissMessages,
      storageType,
    ) || [];

  const finalMessage = message.slice(0, 80);

  setStorageValue(
    StorageValues.DismissMessages,
    dismissMessages.concat(finalMessage),
    storageType,
  );
};

export const checkIsDismissNotification = (
  message: string,
  storageType: StorageTypes,
): boolean => {
  const dismissMessages =
    getStorageValue<string[]>(
      StorageValues.DismissMessages,
      storageType,
    ) || [];

  const hasDismissMessage = dismissMessages.some((dismissMessage) =>
    message.toLowerCase().startsWith(dismissMessage.toLowerCase()),
  );

  return hasDismissMessage;
};
